<mat-toolbar *ngIf='show' fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between start"
  fxLayoutAlign.xs='start start' style='padding-top: 20px'>
  <div>
    <img src="./assets/images/logo-black-2.png" width="200px" />
    <div class='list-item'>
      info&#64;golfgameskeeper.com
    </div>
  </div>
  <div>
    <h3 class='text-header'>Products</h3>
    <hr class='accent-background accent-color'>
    <div class='list-item'>
      <a routerLink="products">
        Subsciption Options</a>
      <br />
      <a routerLink="golf-mobile-app"> Mobile App</a>
      <br />
      <a routerLink="pricing"> Pricing</a>
    </div>
  </div>
  <div>
    <h3 class='text-header'>Support</h3>
    <hr class='accent-background accent-color'>
    <div class='list-item'>
      <a routerLink="how-to"> How-to Guides</a>
    </div>
  </div>
  <div>
    <h3 class='text-header'>Company</h3>
    <hr class='accent-background accent-color'>
    <div class='list-item'>
      <a routerLink="privacy"> Privacy Policy</a>
      <br />
      <a routerLink='returns'> Cancellation/Return Policy</a>
      <br />
      <a routerLink="terms"> Terms &amp; Conditions</a>
    </div>
  </div>
  <div>
    <h3 class='text-header'>Social Media</h3>
    <hr class='accent-background accent-color'>
    <span style='color: black;' class='pads'>
      <a href='https://www.facebook.com/golfgameskeeper/'>
        <i class="fa fa-facebook" aria-hidden="true"></i>
      </a>
      <a href='https://www.instagram.com/golfgameskeeper/'>
        <i class="fa fa-instagram" aria-hidden="true"></i>
      </a>
      <a href='https://www.linkedin.com/company/golfgameskeeper/'>
        <i class="fa fa-linkedin" aria-hidden="true"></i>
      </a>
    </span>

  </div>
</mat-toolbar>
<div *ngIf="show" style="text-align: center; padding: 8px 0; font-size: 11px; color: #9e9e9e;">
  v{{version}}
</div>